import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-card', {
    staticClass: "shadow-sm"
  }, [_c('b-card-body', {
    staticClass: "mb-4 px-6 pt-6"
  }, [_vm.loading ? _c('div', [_c('b-row', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "col-6 border-right"
  }, [_c('b-skeleton', {
    staticClass: "mx-auto mb-3",
    attrs: {
      "width": "60%",
      "height": "18px"
    }
  }), _c('b-skeleton', {
    staticClass: "mx-auto",
    attrs: {
      "width": "70%",
      "height": "48px"
    }
  })], 1), _c('div', {
    staticClass: "col-6"
  }, [_c('b-skeleton', {
    staticClass: "mx-auto mb-3",
    attrs: {
      "width": "60%",
      "height": "18px"
    }
  }), _c('b-skeleton', {
    staticClass: "mx-auto",
    attrs: {
      "width": "70%",
      "height": "48px"
    }
  })], 1)])], 1) : _c('div', [_c('b-row', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "col-6 border-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'contasReceber'
        });
      }
    }
  }, [_c('b-card-title', {
    staticClass: "mb-5"
  }, [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "arrow-down-circle-fill",
      "color": "#2ECC71"
    }
  }), _c('span', [_vm._v("A receber hoje")])], 1), _c('h2', {
    staticClass: "display-4 mb-0 font-weight-bold",
    style: {
      color: '#2ECC71',
      opacity: _vm.totalReceberHoje > 0 ? 1 : 0.7
    }
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.totalReceberHoje)) + " ")])], 1), _c('div', {
    staticClass: "col-6",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'contasPagarLista'
        });
      }
    }
  }, [_c('b-card-title', {
    staticClass: "mb-5"
  }, [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "arrow-up-circle-fill",
      "color": "#E74C3C"
    }
  }), _c('span', [_vm._v("A pagar hoje")])], 1), _c('h2', {
    staticClass: "display-4 mb-0 font-weight-bold",
    style: {
      color: '#E74C3C',
      opacity: _vm.totalPagarHoje > 0 ? 1 : 0.7
    }
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.totalPagarHoje)) + " ")])], 1)])], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };